import { WizardProgressBar } from '@/components/WizardProgressBar';
import { StepGroups, SubflowSteps } from '@/types/steps';
import endsWith from 'lodash/endsWith';
import React, { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import {
  BackButton,
  Container,
  HeadContainer,
  HeadWrapper,
  MainIntro,
  MainOther,
  MainPet,
  MainProducts,
  PromoBanner,
  StyledLogo,
  Top
} from '../components';

type StepLayoutProps = {
  view: StepGroups;
};

export const StepLayout: React.FC<StepLayoutProps> = ({ view }) => {
  const { pathname } = useLocation();

  const showBackButton = !endsWith(pathname, SubflowSteps.Intro);
  const hideHeader = endsWith(pathname, SubflowSteps.CalculatingPlan);

  const ViewWrapper = useMemo(() => {
    switch (view) {
      case StepGroups.Intro:
        return MainIntro;
      case StepGroups.Pet:
        return MainPet;
      case StepGroups.Products: {
        if (hideHeader) return MainOther;
        return MainProducts;
      }
      default:
        return React.Fragment;
    }
  }, [pathname, hideHeader, view]);

  return (
    <Container $view={view} $loadingScreen={hideHeader}>
      <PromoBanner />
      {hideHeader ? (
        <div />
      ) : (
        <HeadWrapper>
          <HeadContainer>
            <Top>
              {showBackButton && <BackButton />}
              <StyledLogo aria-label="petplate logo" />
            </Top>
            <WizardProgressBar />
          </HeadContainer>
        </HeadWrapper>
      )}
      <ViewWrapper>
        <Outlet />
      </ViewWrapper>
    </Container>
  );
};
